import { useState, useEffect } from "react";
import { DefaultDocumentos, IDocumentos } from "../../interfaces/IDocumentos";
import { Modal } from 'react-bootstrap-v5';
import clsx from "clsx";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import DocumentosService from "../../services/DocumentosService";

interface Extensao {
  id: number;
  texto: string;
  marcado: boolean;
}

const DocumentosModal = ({ toggleModal, show, documento, title }: { toggleModal: (recarregarInformacoes?: boolean) => void, show: boolean, documento: IDocumentos, title: string }) => {
 
  const [extensoes, setExtensoes] = useState<Extensao[]>([]);
  const documentoSchema = Yup.object().shape({
    nome: Yup.string().max(50, 'Máximo 50 caracteres').required('Nome é obrigatório')
  })
  const formInitialValues: IDocumentos = {
    id: 0,
    nome: '',
    xml: false,
    txt: false,
    pdf: false,
    doc: false,
    xls: false,
    ofx: false,
    csv: false,
    json: false,
    xlsx: false
  };
  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: documentoSchema,
    onSubmit: async (documento, { setSubmitting }) => {
      function funcaoSucesso() {
        setSubmitting(false);
        toggleModal(true);
      }

      Object.getOwnPropertyNames(documento).filter(x => x !== 'id' && x !== 'nome').sort((a, b) => a > b ? 1 : -1).forEach((x, index) => (documento[x as keyof IDocumentos] as boolean) = extensoes[index + 1].marcado);

      if ((documento?.id ?? 0) === 0) {
        await DocumentosService.criar(documento, funcaoSucesso, 'Documento foi adicionada com sucesso');
      } else {
        await DocumentosService.atualizar(documento, funcaoSucesso, 'Documento foi editado com sucesso');
      }
    }
  })

  useEffect(() => {
    let extensoesTemp: Extensao[] = [
      { id: 0, texto: 'Todos', marcado: false }
    ];

    if (!documento?.id) {
      //eslint-disable-next-line
      documento = DefaultDocumentos;
    }

    formik.setValues(documento);

    !documento.nome && formik.setFieldTouched('nome', false);

    Object.getOwnPropertyNames(documento).filter(x => x !== 'id' && x !== 'nome').sort((a, b) => a > b ? 1 : -1).forEach((x, index) => {
      const texto = x.toUpperCase();
      const marcado = documento[x as keyof IDocumentos] as boolean;
      const extensao: Extensao = { id: index + 1, texto: texto, marcado: marcado };

      extensoesTemp.push(extensao);
    });

    setExtensoes(extensoesTemp);
    tentarMarcarTodos(extensoesTemp);

    //eslint-disable-next-line
  }, [documento]);

  function tentarMarcarTodos(array: Extensao[]) {
    const permitidoMarcar = array.filter(x => x.id !== 0).find(x => !x.marcado);

    array[0].marcado = !permitidoMarcar;

    setExtensoes([...array]);
  }

  function trocarValor(id: number, valor: boolean) {
    let extensoesTemp = extensoes; 
      
    if (id === 0) {
      extensoesTemp.forEach(x => x.marcado = valor);
              
      setExtensoes([...extensoesTemp]);
    } else {
      let extensaoTemp = extensoesTemp.find(x => x.id === id);

      if (extensaoTemp) {
        extensaoTemp.marcado = valor;

        setExtensoes([...extensoesTemp]);
        tentarMarcarTodos(extensoesTemp);
      }
    }
  }

  return <Modal size='lg' centered={true} show={show} onHide={() => toggleModal()}>
    <div className="modal-content">

      <div className="modal-header">
        <h5 className="modal-title titulo-modal">{title}</h5>
        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
          <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }}/>
        </div>
      </div>

      <div className="modal-body">
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="form-nome" className="form-label required">Nome do Documento</label>
            <input {...formik.getFieldProps('nome')} placeholder="Digite algo" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.nome && formik.errors.nome,
              },
              {
                'is-valid': formik.touched.nome && !formik.errors.nome,
              }
              )} id="form-nome" />
          </div>
          <div className="col-md-12">
            <label htmlFor="form-extensoes" className="form-label required mt-5">Extensões aceitas</label>
            <div id="form-extensoes" className='col-md-12' style={{display: 'flex', flexFlow: 'wrap'}}>
              {
                extensoes.length > 1 && extensoes.map((x, index) => <div key={index} style={{margin: '0 30px', width: '80px'}} onClick={() => trocarValor(x.id, !x.marcado)}>
                  <input type="checkbox" style={{marginRight: '10px'}} checked={x.marcado} onChange={() => trocarValor(x.id, x.marcado)}/>
                  <label className="form-label" style={{userSelect: 'none'}} onClick={() => trocarValor(x.id, x.marcado)}>{x.texto}</label>
                </div>)
              }
            </div>
          </div>
        </form>
      </div>

      <div className="modal-footer" style={{ margin: '0 auto' }}>
        <button disabled={formik.isSubmitting} onClick={() => toggleModal(false)} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
        <button disabled={formik.isSubmitting || !formik.isValid} onClick={async () => await formik.submitForm()} type="button" className="btn btn-primario ms-5">
          { !formik.isSubmitting && ((documento?.id ?? 0) === 0 ? 'ADICIONAR' : 'EDITAR') }
          {
            formik.isSubmitting && (
            <span className='indicator-progress' style={{ display: 'block' }}>
                Salvando...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  </Modal>
}

export default DocumentosModal;